import EditContainer from './game-edit-container';

export default {
    path: '/:id',
    exact: true,
    component: EditContainer,
    routes: []
};



// WEBPACK FOOTER //
// ./src/js/routes/app/routes/games/routes/edit/index.js